'use strict';

const _ = require('lodash');

const stickyClass = 'has-sticky-header';
const $html = $('html');
const $body = $('body');
const $topBanner = $('#header');
let $plpFilters;
let topBannerHeight = $topBanner.outerHeight();
let headerOffsetTop = $topBanner.offset().top || 0;
let plpFilterHeight = 0;
let hasStickyFilter;
let stickyHeight;

const initPLPFilters = () => {
    $plpFilters = $('.mobile-refinement-filter');
    if ($plpFilters.length) {
        plpFilterHeight = $plpFilters.outerHeight() + 10;
        let $expandedInnerMenu = $plpFilters.find('.mobile-refinement-filter__c-accordion__item.is-expanded .mobile-refinement-filter__c-accordion__body');
        if ($expandedInnerMenu.length) {
            plpFilterHeight -= $expandedInnerMenu.outerHeight();
        }
        $plpFilters.css('top', topBannerHeight + 'px');
    } else {
        plpFilterHeight = 0;
    }
};

const doSticky = () => {
    const scrollTop = Math.max($html.scrollTop(), $body.scrollTop());
    const isSticky = scrollTop >= headerOffsetTop;
    $html.toggleClass(stickyClass, isSticky);
    hasStickyFilter = $plpFilters.length && ['fixed', 'sticky'].includes(window.getComputedStyle($plpFilters[0]).position) ? true : false;
    stickyHeight = hasStickyFilter ? (topBannerHeight + plpFilterHeight) : topBannerHeight;
    $body.css('padding-top', isSticky ? stickyHeight : '');
};

const resetSticky = () => {
    initPLPFilters(); // re-initialize PLP filters as they may have been replaced by AJAX.
    $html.removeClass(stickyClass);
    $body.css('padding-top', '');
    topBannerHeight = $topBanner.outerHeight();
    headerOffsetTop = $topBanner.offset().top || 0;
    if ($plpFilters.length) {
        $plpFilters.css('top', topBannerHeight + 'px');
    }

    doSticky();
};

module.exports = {
    init: function() {
        initPLPFilters();
        doSticky();
        $(window)
        .on('scroll', doSticky)
        .on('resize', _.throttle(resetSticky, 100));
    },
    resetSticky: resetSticky
};
